export const SSE_CONTENT_TYPE = "text/event-stream";
export const FRAME_TYPE = { UPDATE: "update", TOAST: "toast" };

// turns a raw SSE frame into its JSON payload, or null for comment/heartbeat and malformed frames
const parseFrame = (rawFrame) => {
  const dataLines = rawFrame
    .split("\n")
    .filter((line) => line.startsWith("data:"))
    .map((line) => line.replace(/^data:\s?/, ""));
  if (dataLines.length === 0) return null;
  try {
    return JSON.parse(dataLines.join("\n"));
  } catch {
    return null;
  }
};

/**
 * Create a stateful SSE parser that buffers partial frames across chunks. Each push returns the
 * parsed payloads of any complete frames, skipping heartbeat comments and malformed JSON.
 * @returns {{ push: (chunk: string) => object[] }}
 */
export const createSseFrameParser = () => {
  let buffer = "";
  return {
    push(chunk) {
      buffer += chunk;
      const events = [];
      let boundary;
      while ((boundary = buffer.indexOf("\n\n")) !== -1) {
        const rawFrame = buffer.slice(0, boundary);
        buffer = buffer.slice(boundary + 2);
        const payload = parseFrame(rawFrame);
        if (payload) events.push(payload);
      }
      return events;
    }
  };
};
